var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-edit",style:(_vm.theme
      ? {
          color: _vm.theme.highlightBtnColor,
          backgroundColor: _vm.theme.highlightBtnBg
        }
      : {}),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('i',{class:("icon zsicon " + _vm.icon)}):_vm._e(),_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.txt))])])}
var staticRenderFns = []

export { render, staticRenderFns }